import SpeechRecognition from "~/utils/speech-recognition/SpeechRecognition";

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      speechRecognition: SpeechRecognition,
    },
  };
});
